import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import UpdateAddress from './UpdateAddress';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading,
    data,
    error,
    message,
    newAddress,
  } = state.address;
  return {
    isLoading,
    data,
    error,
    message,
    newAddress,
  };
}

const Styled = withStyles(styles)(UpdateAddress);

export default connect(
  mapStateToProps,
)(Styled);
